import { TradeWorkflowSpec } from './trade-workflow-spec.model';

export const EMS_V3_ACCESS_LEVEL = 3;

export const hasEmsV3Access = ({ emsAccessLevel }: Pick<TradeWorkflowSpec, 'emsAccessLevel'>): boolean =>
  emsAccessLevel === EMS_V3_ACCESS_LEVEL;
